import { render, staticRenderFns } from "./PublishedItem.vue?vue&type=template&id=79215094"
import script from "./PublishedItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublishedItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports